import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { PageState } from './page.state';
import { PageObjectService } from './page-object.service';
import { OpenProprietaryPoliciesState } from './open-proprietary-policies.state';

@NgModule({
    imports: [NgxsModule.forFeature([PageState, OpenProprietaryPoliciesState])],
    providers: [PageObjectService]
})
export class PageObjectModule { }
